import * as THREE from 'three';

export class PerspectiveCamera extends THREE.PerspectiveCamera {
    target: THREE.Vector3;

    constructor(fov?: number, aspect?: number, near?: number, far?: number) {
        super(fov, aspect, near, far);
        this.target = new THREE.Vector3();
    }

    lookAt(vector: THREE.Vector3): void;
    lookAt(x: number, y: number, z: number): void;
    lookAt(vector: THREE.Vector3 | number, y?: number, z?: number): void {
        if (vector instanceof THREE.Vector3) {
            this.target.copy(vector);
        } else {
            this.target.set(vector, y || 0, z || 0);
        }
        super.lookAt(vector, y, z);
    }
}
